import { LITRES_PER_USG } from './fuelPlan'
import type { FuelUnit } from './weightBalance'

// Fuel and oil as a pilot enters them in the flight log. Stored in litres;
// the form lets the pilot type the unit the dipstick or the bowser reads.
// Pure; tested from apps/api/test/domain/fuelOil.test.ts.

// Fuel's units (FUEL_UNITS) are weightBalance.ts's.
export const OIL_UNITS = ['l', 'qt'] as const
export type OilUnit = (typeof OIL_UNITS)[number]

export const LITRES_PER_US_QUART = 0.946352946

const LITRES_PER: Record<FuelUnit | OilUnit, number> = {
  l: 1,
  usg: LITRES_PER_USG,
  qt: LITRES_PER_US_QUART,
}

// The log keeps tenths of a litre (numeric(6,1) / numeric(4,1)).
const round = (value: number, decimals: number) => {
  const factor = 10 ** decimals
  return Math.round(value * factor) / factor
}

export const toLitres = (amount: number, unit: FuelUnit | OilUnit): number => round(amount * LITRES_PER[unit], 1)

// Two decimals outside litres: a tenth of a US gallon is 0.38 l.
export const fromLitres = (litres: number, unit: FuelUnit | OilUnit): number =>
  round(litres / LITRES_PER[unit], unit === 'l' ? 1 : 2)

// Which of fuel and oil the pilot has neither entered nor marked as "none
// added" (an explicit none is stored as 0, a skipped field as null). Not
// blocking: the form asks the pilot to confirm before saving.
export function unrecordedFuelOil(fuelAddedLitres: number | null, oilAddedLitres: number | null): ('fuel' | 'oil')[] {
  const missing: ('fuel' | 'oil')[] = []
  if (fuelAddedLitres === null) missing.push('fuel')
  if (oilAddedLitres === null) missing.push('oil')
  return missing
}
